import { DUMMY_XY_COORDINATES } from 'components/Map/constants';
import { IArea, SpriteType } from 'types/map';
import * as PIXI from "pixi.js";
import getSelectionSpriteCoordinates from 'components/Map/util/getSelectionSpriteCoordinates';
import getMainDestinationSelectionCoordinates from 'components/Map/util/getMainDestinationSelectionCoordinates';

function pointFromXY({ x, y }: { x: number, y: number }) {
  return new PIXI.Point(x / 2, -y / 2);
}

export default function getPositionForSprite(area: IArea, whatKind: SpriteType): PIXI.IPoint {
  const {
    areaKey,
    mainDestinationSpriteTopLeftX,
    mainDestinationSpriteTopLeftY,
    spriteTopLeftX,
    spriteTopLeftY,
  } = area;

  switch (whatKind) {
    case 'available': {
      if (spriteTopLeftX === undefined || spriteTopLeftY === undefined) {
        console.error(`getPositionForSprite(${areaKey}): this area has no sprite coords`);
        console.error(area);
        return pointFromXY(DUMMY_XY_COORDINATES);
      }
      return new PIXI.Point(spriteTopLeftX / 2, -spriteTopLeftY / 2);
    }
    case 'selection':
      return pointFromXY(getSelectionSpriteCoordinates(area));
    case 'main-destination-selection': {
      return pointFromXY(getMainDestinationSelectionCoordinates(area));
    }
    case 'main-destination':
    default: { // case 'main-destination'
      if (mainDestinationSpriteTopLeftX === undefined || mainDestinationSpriteTopLeftY === undefined) {
        console.error(`getPositionForSprite(${areaKey}): no main destination sprite coordinates`);
        return pointFromXY(DUMMY_XY_COORDINATES);
      }
      return new PIXI.Point(mainDestinationSpriteTopLeftX / 2, -mainDestinationSpriteTopLeftY / 2);
    }

  }
}
